import { render } from "./BibliotecaRivendelView.vue?vue&type=template&id=0aea9842"
import script from "./BibliotecaRivendelView.vue?vue&type=script&lang=js"
export * from "./BibliotecaRivendelView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__